// extracted by css-extract-rspack-plugin
export default {"panel":"rcwJ1CMBbmkIcuUK","label":"nCbBULMiLzIrAi_X","header":"jfi6430AHNE8AYqo"};